/* Stormrock · page collection : filtres effet / culture, tri par prix, épuisés repliés, sans rechargement. */
(() => {
  const qa = (s, r) => Array.from((r || document).querySelectorAll(s));
  function init(root) {
    if (root.dataset.srcReady) return;
    root.dataset.srcReady = '1';
    const g1 = root.querySelector('[data-g1]'), g2 = root.querySelector('[data-g2]');
    if (!g1 || !g2) return;
    const cards = qa('[data-cc]', root);
    const st = { eff: null, cult: null, sort: null, out: false };
    const more = root.querySelector('[data-more]'), empty = root.querySelector('[data-empty]');
    const u1 = root.dataset.u1, u2 = root.dataset.u2;
    function apply() {
      let list = cards.filter((c) => (!st.eff || c.dataset.eff === st.eff) && (!st.cult || c.dataset.cult === st.cult));
      if (st.sort) list.sort((a, b) => (st.sort === 'asc' ? 1 : -1) * ((+a.dataset.sort || 0) - (+b.dataset.sort || 0)));
      else list.sort((a, b) => (+a.dataset.pos) - (+b.dataset.pos));
      const avail = list.filter((c) => !('so' in c.dataset)), out = list.filter((c) => 'so' in c.dataset);
      const shown = st.out ? avail.concat(out) : avail;
      cards.forEach((c) => { c.hidden = shown.indexOf(c) < 0; });
      shown.forEach((c, i) => (i < 4 ? g1 : g2).appendChild(c));
      cards.filter((c) => c.hidden).forEach((c) => g2.appendChild(c));
      qa('[data-cn]', root).forEach((n) => { n.textContent = avail.length; });
      qa('[data-u]', root).forEach((n) => { n.textContent = avail.length > 1 ? u2 : u1; });
      const filtered = !!(st.eff || st.cult || st.sort);
      qa('[data-reset]', root).forEach((n) => { n.hidden = !filtered; });
      qa('button[data-reset-btn]', root).forEach((b) => { if (!b.closest('[data-reset]')) b.hidden = !filtered; });
      qa('.chip[data-f]', root).forEach((c) => c.classList.toggle('on', st[c.dataset.f] === c.dataset.v));
      if (empty) empty.hidden = shown.length > 0;
      if (more) {
        more.hidden = out.length === 0;
        more.setAttribute('aria-expanded', st.out);
        more.querySelector('[data-m]').hidden = st.out;
        more.querySelector('[data-l]').hidden = !st.out;
        more.classList.toggle('open', st.out);
      }
    }
    root.addEventListener('click', (e) => {
      const chip = e.target.closest('.chip[data-f]');
      if (chip) { const f = chip.dataset.f, v = chip.dataset.v; st[f] = st[f] === v ? null : v; apply(); return; }
      if (e.target.closest('[data-reset-btn]')) { st.eff = st.cult = st.sort = null; apply(); return; }
      if (e.target.closest('[data-more]')) { st.out = !st.out; apply(); }
    });
    apply();
  }
  const boot = () => qa('[data-src]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', () => setTimeout(boot, 30));
})();
